class ReportsApiResponseModel {
  // #region Props

  // #endregion
  constructor({url, time}) {
    return {
      url,
      time,
    };
  }
}

export default ReportsApiResponseModel;
